import { BaseService } from 'core/services';
import EligibilityStatusRouteService from './EligibilityStatusRouteService';

class EligibilityStatusService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new EligibilityStatusRouteService());
    }
}

export default EligibilityStatusService;
